import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "employee-condition-modal" }
const _hoisted_2 = { class: "employee-condition-modal__head" }
const _hoisted_3 = { class: "employee-condition-modal__head-main" }
const _hoisted_4 = { class: "employee-condition-modal__head-icon" }
const _hoisted_5 = { class: "employee-condition-modal__head-text" }
const _hoisted_6 = { class: "employee-condition-modal__title" }
const _hoisted_7 = { class: "employee-condition-modal__subtitle" }
const _hoisted_8 = { class: "employee-condition-modal__body" }
const _hoisted_9 = {
  key: 0,
  class: "employee-condition-modal__empty"
}
const _hoisted_10 = { class: "employee-condition-modal__section-head" }
const _hoisted_11 = { class: "employee-condition-modal__section-title" }
const _hoisted_12 = {
  key: 0,
  class: "employee-condition-modal__section-badge"
}
const _hoisted_13 = {
  key: 0,
  class: "employee-condition-modal__kv-grid"
}
const _hoisted_14 = { class: "employee-condition-modal__kv-label" }
const _hoisted_15 = { class: "employee-condition-modal__kv-value" }
const _hoisted_16 = {
  key: 1,
  class: "employee-condition-modal__settings"
}
const _hoisted_17 = { class: "employee-condition-modal__setting-text" }
const _hoisted_18 = { class: "employee-condition-modal__setting-label" }
const _hoisted_19 = {
  key: 0,
  class: "employee-condition-modal__setting-desc"
}
const _hoisted_20 = {
  key: 2,
  class: "employee-condition-modal__note"
}
const _hoisted_21 = {
  key: 3,
  class: "employee-condition-modal__warning"
}
const _hoisted_22 = {
  key: 4,
  class: "employee-condition-modal__fields"
}
const _hoisted_23 = { class: "employee-condition-modal__field-head" }
const _hoisted_24 = { class: "employee-condition-modal__field-label" }
const _hoisted_25 = {
  key: 0,
  class: "employee-condition-modal__field-amount"
}
const _hoisted_26 = {
  key: 0,
  class: "employee-condition-modal__field-detail"
}
const _hoisted_27 = { class: "employee-condition-modal__footer" }

import LoadingOverlay from '@/components/common/LoadingOverlay.vue';

export interface HomeWageEmployeeConditionKvItem {
  label: string;
  value: string;
  highlight?: boolean;
}

export interface HomeWageEmployeeConditionSettingItem {
  label: string;
  active: boolean;
  description?: string;
}

export interface HomeWageEmployeeConditionFieldItem {
  label: string;
  amount?: string;
  detail: string;
}

export type HomeWageEmployeeConditionSectionType =
  | 'summary'
  | 'settings'
  | 'note'
  | 'warning'
  | 'fields';

export interface HomeWageEmployeeConditionSection {
  id: string;
  title: string;
  type: HomeWageEmployeeConditionSectionType;
  icon?: string;
  badge?: string;
  kvItems?: HomeWageEmployeeConditionKvItem[];
  settingItems?: HomeWageEmployeeConditionSettingItem[];
  fieldItems?: HomeWageEmployeeConditionFieldItem[];
  noteLines?: string[];
  warningLines?: string[];
}


export default /*@__PURE__*/_defineComponent({
  __name: 'HomeWageEmployeeConditionModal',
  props: {
    modelValue: { type: Boolean, default: false },
    employeeName: { default: '-' },
    yearMonthLabel: { default: '' },
    sections: { default: () => [] },
    loading: { type: Boolean, default: false }
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit: __emit }) {



const emit = __emit;

const getDetailLines = (detail: string): string[] =>
  detail
    .split('\n')
    .map((line) => line.trim())
    .filter((line) => line && line !== '=');

const formatNoteLine = (line: string): string =>
  line.replace(/^[★⚠️✓•\-\s]+/, '').trim() || line;

const getNoteLineClass = (line: string): string => {
  if (line.startsWith('★') || line.startsWith('⚠')) return 'employee-condition-modal__note-line--emphasis';
  if (line.startsWith('✓')) return 'employee-condition-modal__note-line--success';
  if (line.startsWith('[') || line.startsWith('【')) return 'employee-condition-modal__note-line--heading';
  if (line.startsWith('•')) return 'employee-condition-modal__note-line--bullet';
  return '';
};

const getNoteLineIcon = (line: string): string | null => {
  if (line.startsWith('★')) return 'mdi-star-circle-outline';
  if (line.startsWith('⚠')) return 'mdi-alert-outline';
  if (line.startsWith('✓')) return 'mdi-check-circle-outline';
  return null;
};

const getDetailLineClass = (line: string): string => {
  if (line.startsWith('★') || line.startsWith('【') || line.startsWith('[')) {
    return 'employee-condition-modal__field-line--heading';
  }
  if (line.startsWith('조건:') || line.startsWith('선택:') || line.startsWith('고정:')) {
    return 'employee-condition-modal__field-line--meta';
  }
  if (/^=\s/.test(line)) {
    return 'employee-condition-modal__field-line--result';
  }
  if (line.includes('=') && /\d/.test(line)) {
    return 'employee-condition-modal__field-line--formula';
  }
  return '';
};

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_openBlock(), _createBlock(_component_v_dialog, {
    "model-value": __props.modelValue,
    "max-width": "760",
    scrollable: "",
    "content-class": "employee-condition-dialog",
    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (emit('update:modelValue', $event)))
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("header", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createVNode(_component_v_icon, {
                size: "20",
                color: "white"
              }, {
                default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
                  _createTextVNode("mdi-text-box-check-outline", -1)
                ]))]),
                _: 1
              })
            ]),
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("h3", _hoisted_6, _toDisplayString(__props.employeeName) + " 사원 멘트", 1),
              _createElementVNode("p", _hoisted_7, _toDisplayString(__props.yearMonthLabel) + " · 적용 조건 및 산출 근거 ", 1)
            ])
          ]),
          _createVNode(_component_v_btn, {
            icon: "",
            size: "small",
            variant: "text",
            class: "employee-condition-modal__close",
            "aria-label": "닫기",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('update:modelValue', false)))
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_icon, { size: "18" }, {
                default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
                  _createTextVNode("mdi-close", -1)
                ]))]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createVNode(LoadingOverlay, {
            show: __props.loading,
            text: "불러오는 중...",
            variant: "light"
          }, null, 8, ["show"]),
          (!__props.loading && __props.sections.length === 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                _createVNode(_component_v_icon, {
                  size: "40",
                  color: "#94a3b8"
                }, {
                  default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
                    _createTextVNode("mdi-information-outline", -1)
                  ]))]),
                  _: 1
                }),
                _cache[6] || (_cache[6] = _createElementVNode("p", null, "표시할 조건 정보가 없습니다.", -1))
              ]))
            : _createCommentVNode("", true),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.sections, (section) => {
            return (_openBlock(), _createElementBlock("section", {
              key: section.id,
              class: _normalizeClass(["employee-condition-modal__section", `employee-condition-modal__section--${section.type}`])
            }, [
              _createElementVNode("header", _hoisted_10, [
                _createVNode(_component_v_icon, {
                  size: "16",
                  class: "employee-condition-modal__section-icon"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(section.icon), 1)
                  ]),
                  _: 2
                }, 1024),
                _createElementVNode("h4", _hoisted_11, _toDisplayString(section.title), 1),
                (section.badge)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_12, _toDisplayString(section.badge), 1))
                  : _createCommentVNode("", true)
              ]),
              (section.type === 'summary' && section.kvItems?.length)
                ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(section.kvItems, (item, idx) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: `${section.id}-kv-${idx}`,
                        class: _normalizeClass(["employee-condition-modal__kv-item", { 'employee-condition-modal__kv-item--highlight': item.highlight }])
                      }, [
                        _createElementVNode("span", _hoisted_14, _toDisplayString(item.label), 1),
                        _createElementVNode("span", _hoisted_15, _toDisplayString(item.value), 1)
                      ], 2))
                    }), 128))
                  ]))
                : (section.type === 'settings' && section.settingItems?.length)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(section.settingItems, (item, idx) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: `${section.id}-set-${idx}`,
                          class: "employee-condition-modal__setting-row"
                        }, [
                          _createElementVNode("span", {
                            class: _normalizeClass(["employee-condition-modal__setting-chip", item.active ? 'employee-condition-modal__setting-chip--on' : 'employee-condition-modal__setting-chip--off'])
                          }, _toDisplayString(item.active ? '적용' : '미적용'), 3),
                          _createElementVNode("div", _hoisted_17, [
                            _createElementVNode("span", _hoisted_18, _toDisplayString(item.label), 1),
                            (item.description)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_19, _toDisplayString(item.description), 1))
                              : _createCommentVNode("", true)
                          ])
                        ]))
                      }), 128))
                    ]))
                  : (section.type === 'note' && section.noteLines?.length)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(section.noteLines, (line, idx) => {
                          return (_openBlock(), _createElementBlock("p", {
                            key: `${section.id}-note-${idx}`,
                            class: _normalizeClass(["employee-condition-modal__note-line", getNoteLineClass(line)])
                          }, [
                            (getNoteLineIcon(line))
                              ? (_openBlock(), _createBlock(_component_v_icon, {
                                  key: 0,
                                  size: "14",
                                  class: "employee-condition-modal__note-icon"
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(getNoteLineIcon(line)), 1)
                                  ]),
                                  _: 2
                                }, 1024))
                              : _createCommentVNode("", true),
                            _createElementVNode("span", null, _toDisplayString(formatNoteLine(line)), 1)
                          ], 2))
                        }), 128))
                      ]))
                    : (section.type === 'warning' && section.warningLines?.length)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(section.warningLines, (line, idx) => {
                            return (_openBlock(), _createElementBlock("div", {
                              key: `${section.id}-warn-${idx}`,
                              class: "employee-condition-modal__warning-item"
                            }, [
                              _createVNode(_component_v_icon, {
                                size: "16",
                                color: "#c62828"
                              }, {
                                default: _withCtx(() => [...(_cache[7] || (_cache[7] = [
                                  _createTextVNode("mdi-alert-circle-outline", -1)
                                ]))]),
                                _: 1
                              }),
                              _createElementVNode("span", null, _toDisplayString(line), 1)
                            ]))
                          }), 128))
                        ]))
                      : (section.type === 'fields' && section.fieldItems?.length)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(section.fieldItems, (item, idx) => {
                              return (_openBlock(), _createElementBlock("article", {
                                key: `${section.id}-field-${idx}`,
                                class: "employee-condition-modal__field-card"
                              }, [
                                _createElementVNode("div", _hoisted_23, [
                                  _createElementVNode("span", _hoisted_24, _toDisplayString(item.label), 1),
                                  (item.amount)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_25, _toDisplayString(item.amount) + "원", 1))
                                    : _createCommentVNode("", true)
                                ]),
                                (getDetailLines(item.detail).length)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(getDetailLines(item.detail), (line, lineIdx) => {
                                        return (_openBlock(), _createElementBlock("p", {
                                          key: `${section.id}-field-${idx}-line-${lineIdx}`,
                                          class: _normalizeClass(["employee-condition-modal__field-line", getDetailLineClass(line)])
                                        }, _toDisplayString(line), 3))
                                      }), 128))
                                    ]))
                                  : _createCommentVNode("", true)
                              ]))
                            }), 128))
                          ]))
                        : _createCommentVNode("", true)
            ], 2))
          }), 128))
        ]),
        _createElementVNode("footer", _hoisted_27, [
          _createVNode(_component_v_btn, {
            variant: "text",
            class: "btn-close",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (emit('update:modelValue', false)))
          }, {
            default: _withCtx(() => [...(_cache[8] || (_cache[8] = [
              _createTextVNode(" 닫기 ", -1)
            ]))]),
            _: 1
          })
        ])
      ])
    ]),
    _: 1
  }, 8, ["model-value"]))
}
}

})